import { MOBILE_QUERY, useMediaQuery } from './useMediaQuery';

export const useIsMobile = () => useMediaQuery(MOBILE_QUERY);
